"use client";

import { IZapierForm } from "@/sanity/globals/ZapierForm";

export async function submitFormDataToZapier(
	fieldData: Record<string, any>,
	formData: IZapierForm,
) {
	const url = formData.settings.url;

	try {
		await fetch(url, {
			method: "POST",
			mode: "no-cors",
			body: JSON.stringify(fieldData),
		});

		return {
			success: true,
			message: "Form submitted successfully",
			submission: null,
		};
	} catch (e) {
		console.log(e);
		return {
			success: false,
			message: "Form submission failed",
		};
	}
}
